import { render, staticRenderFns } from "./BoxLabelBorder.vue?vue&type=template&id=a8f83160&scoped=true&"
import script from "./BoxLabelBorder.vue?vue&type=script&lang=js&"
export * from "./BoxLabelBorder.vue?vue&type=script&lang=js&"
import style0 from "./BoxLabelBorder.vue?vue&type=style&index=0&id=a8f83160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f83160",
  null
  
)

export default component.exports